export enum RedeemResultCode {
    NotZero,
    NoEnoughToMinRedeem,
    Ok,
    NoAvailableToRedeem,
    ServerError,
    NotRedeemAccountOk,
    NotMinMoney,
    NotMaxMoney,
    NeedTask,
    NeedTaskFixed,
    AccountErrorMsg,
}

export enum RedeemRecordState {
    ReviewNoCancel,//不可以取消订单
    ReviewCanCancel,//可以取消订单
    Successful,//成功
    Fail,//失败
    Process,//正在审核

    KycOpen,//KYC
    KycProcess,//2-处理中
    KycOk,//2-处理通过
    KycFail,//4-处理失败
    KycOpenRetry,//5-重试
}

export enum RecordFailState //不能混淆 名字不能乱改 对应fgui控制器名字
{
    None, //无错误
    Cancel, //玩家手动取消订单/用户主动取消兑换
    AutoReject, //自动拒绝场景-风控（防止用户用多个游戏账号薅羊毛，但是都提到同一个兑换账号）
    PeopleReject, //人工审核拒绝场景 - 拒绝兑换（不退游戏内金额）（欺诈/拒付)
    PayFail, //出款失败/打款失败/用户输错兑换账号（退游戏内金额）
    ThirdPartyReject, //第三方返回失败/用户PAYPAL未注册/用户PAYPAL错误
    LongLongAgo, //订单被删除
    OrderFallback, //订单被退回
}

//KYC状态: 0-无需操作 1-待验证 2-处理中 3-通过 4-不通过 5-可重试	string
export enum RedeemKycState
{
    Empty = 0,
    PendingCheck = 1,
    Processing = 2,
    Passed = 3,
    Failed = 4,
    CanRetry = 5,
}